module.exports = __webpack_public_path__ + "img/georgian_bg.5dbe3749.jpeg";